module.exports = __webpack_public_path__ + "static/media/iphone.ac2fa5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Landing/iphone.png
// module id = 270
// module chunks = 0